<template lang="html">
    <div class="modal-mask" data-class="work" @click="closeModal">
        <div class="modal-wrapper" >
            <div class="modal-container large">
                <header class="modal-header">
                    <slot name="modal-header"></slot>
                </header>
                <div class="modal-body" :class="{'short': short=== true}">
                    <slot name="modal-body"></slot>
                </div>
                <footer class="modal-footer">
                    <slot name="modal-footer"></slot>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import CancelAction from '../mixins/CancelAction';
    import DeleteAction from '../mixins/DeleteAction';

    export default {
        props: ['size', 'short', 'closeFunction'],
        mixins:[CancelAction, DeleteAction],
        methods: {
            closeModal(event) {
                if(this.closeFunction != 'undefined' && event.target.className == 'modal-mask') {
                    this.closeFunction();
                }
            }
        },
        mounted() {
        }
    }
</script>

<style lang="css">
</style>
